import type { Profile, SupportedOnboardingTourStep, UpdateOnboardingTourStepOptionHandler } from 'models';
import { useTranslation } from 'react-i18next';
import { useNavigateThroughOnboardingTourSteps } from '../hooks';
import { InfoStep } from '../info-step';

const IntroStep = ({
  onChangeStep,
  onLogout,
  steps,
  viewer,
}: {
  onChangeStep: UpdateOnboardingTourStepOptionHandler;
  onLogout: () => void;
  steps: SupportedOnboardingTourStep[];
  viewer: Profile;
}) => {
  const { t } = useTranslation();
  const { onNavigateToNextStep } = useNavigateThroughOnboardingTourSteps({ onChangeStep, step: 'intro', steps });

  return (
    <InfoStep
      description={t('onboardingTourWelcomeSubtitle', { count: steps.length })}
      primaryButton={{ children: 'Get started', onClick: onNavigateToNextStep }}
      secondaryButton={{ children: 'Log out', onClick: onLogout }}
      title={t('Hello {{firstName}}!', { firstName: viewer.firstName })}
    />
  );
};

export default IntroStep;
